export default "__VITE_ASSET__DEfLAS_x__"